/**
* @license Apache-2.0
*
* Copyright (c) 2019 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Returns the [viewport width][1].
*
* [1]: https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions/8876069#8876069
*
* @private
* @returns {(number|null)} viewport width
*/
function viewportWidth() {
	// "Sniff" whether we are in a browser...
	if ( typeof window === 'undefined' ) {
		return null;
	}
	return Math.max( document.documentElement.clientWidth, window.innerWidth || 0 ); // eslint-disable-line max-len
}


// EXPORTS //

module.exports = viewportWidth;
